module.exports = __webpack_public_path__ + "img/astrac_logo.ee6d476b.png";